import { Collapse } from "@mui/material";
import React, { ReactNode } from "react";
import { RateBuilderBottomToolbar } from "@sinch/components/application/RatelistBuilder/RateTreeItem/RateBuilderBottomToolbar";

interface CollapsibleBottomToolbarProps {
  /** Whether the toolbar should be visible/expanded */
  expanded: boolean;
  /** The toolbar content to display */
  children: ReactNode;
  /** Whether this is an else toolbar (wrapper type) */
  isElseToolbar?: boolean;
  /** Whether the item is wrapped */
  isWrapped?: boolean;
}

/**
 * Collapsible container for bottom toolbar that shows/hides based on expansion state
 */
export const CollapsibleBottomToolbar: React.FC<CollapsibleBottomToolbarProps> = ({
  expanded,
  children,
  isElseToolbar = false,
  isWrapped = false,
}) => (
  <Collapse in={expanded} mountOnEnter unmountOnExit>
    <RateBuilderBottomToolbar elseToolbar={isElseToolbar} isWrapped={isWrapped}>
      {children}
    </RateBuilderBottomToolbar>
  </Collapse>
);
